import React from 'react';
import { Link } from 'react-router-dom';

import './Header.css';

const Header = ({ title, subtitle }) => {
  const menus = ['inicio', 'sobre mí', 'contacto'];

  const returnUrl = (e) => {
    if (e === 'sobre mí') return 'about';
    // if (e === 'contacto') return 'contacto'; // default handles it
    else return e;
  };

  return (
    <nav className="nav">
      <h1>{title.toUpperCase()}</h1>
      <h2>{subtitle.toUpperCase()}</h2>
      <ul className="header-menu">
        {menus.map((e) => (
          <li key={e}>
            <Link to={`/${returnUrl(e)}`}>{e.toUpperCase()}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Header;
